<div class="wf-app" [class.panel-collapsed]="panelCollapsed">

  <!-- ══════════ LEFT PANEL ══════════ -->
  <aside class="panel">

    <!-- Topbar -->
    <header class="topbar">
      <div class="brand">
        <img class="brand-logo" src="/images/wiyak-logo.png" alt="WFleet" />
      </div>
      <div class="live-tag">
        <div class="lpip">
          <span class="lpip-ring"></span>
          <span class="lpip-ring lpip-ring--2"></span>
        </div>
        Live
      </div>
    </header>

    <!-- ── SHIMMER loading ── -->
    <div *ngIf="isLoading" class="pbody shimmer-body">
      <div class="sh-hero">
        <div class="sh-kicker sh"></div>
        <div class="sh-num sh"></div>
        <div class="sh-sub sh"></div>
        <div class="sh-track sh"></div>
      </div>
      <div class="psec" style="padding-top:20px">
        <div class="sh-lbl sh"></div>
        <div class="sh-driver-card sh"></div>
      </div>
      <div class="psec">
        <div class="sh-lbl sh"></div>
        <div class="sh-trio">
          <div class="sh-tile sh"></div>
          <div class="sh-tile sh"></div>
          <div class="sh-tile sh"></div>
        </div>
      </div>
      <div class="psec">
        <div class="sh-lbl sh"></div>
        <div class="sh-route sh"></div>
      </div>
      <div class="psec">
        <div class="sh-lbl sh"></div>
        <div class="sh-contacts">
          <div class="sh-contact sh"></div>
          <div class="sh-contact sh"></div>
        </div>
      </div>
    </div>

    <!-- ── LOADED CONTENT ── -->
    <ng-container *ngIf="!isLoading">

      <!-- TERMINAL STATE mini header -->
      <div *ngIf="isTerminalState" class="terminal-hero anim-in" style="--d:0ms">
        <div class="terminal-hero-icon" [ngClass]="'thi-' + terminalBadgeClass">
          <svg *ngIf="terminalBadgeClass === 'badge-completed'" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
          <svg *ngIf="terminalBadgeClass === 'badge-cancelled'" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          <svg *ngIf="terminalBadgeClass === 'badge-returned'" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M3 10h11a4 4 0 010 8H3"/><polyline points="7 6 3 10 7 14"/></svg>
        </div>
        <div class="terminal-hero-text">
          <div class="terminal-hero-title">{{ terminalTitle }}</div>
          <div class="terminal-hero-sub">{{ terminalSubtitle }}</div>
        </div>
      </div>

      <!-- ACTIVE ORDER: ETA hero (matches reference: bar + ETA + on schedule + Order is … + stepper shell) -->
      <div *ngIf="!isTerminalState" class="eta-hero anim-in" style="--d:0ms">
        <div class="eta-kicker-row">
          <span class="eta-kicker-bar" aria-hidden="true"></span>
          <span class="eta-kicker">Estimated Arrival</span>
        </div>

        <div class="eta-row">
          <div class="eta-number" [class.eta-updating]="showUpdatePulse">{{ totalDuration || '---' }}</div>
          <span class="eta-unit">min</span>
        </div>

        <div class="eta-confirm" *ngIf="totalDuration && totalDuration !== '---'">
          <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
          on schedule
        </div>

        <!-- <div class="eta-state-line" *ngIf="orderTrack?.orderStatus?.status_string">
          Order is <strong>{{ orderTrack.orderStatus.status_string }}</strong>
        </div> -->

        <!-- <div class="eta-last-updated" *ngIf="getLastUpdateTime()">
          Updated · {{ getLastUpdateTime() }}
        </div> -->

        <div class="track-shell anim-in" style="--d:120ms">
          <div class="track">
            @for (step of getStatusSteps(); track $index; let last = $last) {
              <div class="tstep"
                   [class.tstep--done]="step.status === 'completed'"
                   [class.tstep--now]="step.status === 'active'"
                   [class.tstep--wait]="step.status === 'pending'">
                <svg *ngIf="step.status === 'completed'" class="tstep-check" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                {{ step.label }}
              </div>
              <span *ngIf="!last" class="track-arrow" aria-hidden="true">&gt;</span>
            }
          </div>
        </div>
      </div>

      <!-- ── Scrollable body ── -->
      <div class="pbody">

        <!-- DRIVER -->
        <div class="psec anim-in" style="--d:160ms; padding-top:20px" *ngIf="orderTrack?.task?.driver">
          <div class="sec-label">Driver</div>
          <div class="driver-card">
            <div class="dav-wrap">
              <div class="dav">{{ getDriverInitial() }}</div>
              <div class="dav-online"></div>
            </div>
            <div class="dinfo">
              <div class="dname">{{ orderTrack?.task?.driver?.driverName || '---' }}</div>
              <div class="dmeta">+{{ orderTrack?.task?.driver?.driverPhone || '---' }}</div>
            </div>
            <div class="dbtns">
              <a [href]="'tel:+' + orderTrack?.task?.driver?.driverPhone"
                 *ngIf="orderTrack?.task?.driver?.driverPhone"
                 class="dbtn" title="Call">
                <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
              </a>
              <button *ngIf="!orderTrack?.task?.driver?.driverPhone" class="dbtn dbtn--disabled">
                <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
              </button>
            </div>
          </div>
        </div>

        <div class="prule" style="margin-top:20px" *ngIf="orderTrack?.task?.driver"></div>

        <!-- TRIP INFO -->
        <!-- <div class="psec anim-in" style="--d:200ms">
          <div class="sec-label">Trip Info</div>
          <div class="stats-trio">
            <div class="stat-tile stat-tile--eta">
              <div class="st-icon st-icon--indigo">
                <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M3 12a9 9 0 1018 0 9 9 0 00-18 0"/><path d="M12 8v4l3 3"/></svg>
              </div>
              <div class="st-lbl">ETA</div>
              <div class="st-val" [class.st-updating]="showUpdatePulse">{{ totalDuration || '---' }}<span class="st-unit"> min</span></div>
            </div>
            <div class="stat-tile">
              <div class="st-icon st-icon--sage">
                <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>
              </div>
              <div class="st-lbl">Amount</div>
              <div class="st-val">{{ orderTrack?.task?.chargeAmount || '---' }}<span class="st-unit"> KWD</span></div>
            </div>
            <div class="stat-tile">
              <div class="st-icon st-icon--amber">
                <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 9h6M9 13h4"/></svg>
              </div>
              <div class="st-lbl">Package</div>
              <div class="st-val">&times;{{ orderTrack?.task?.quantity || '0' }}<span class="st-unit"> item</span></div>
            </div>
          </div>
        </div> -->

        <!-- <div class="prule" style="margin-top:20px"></div> -->

        <!-- ROUTE -->
        <div class="psec anim-in" style="--d:240ms"
             *ngIf="orderTrack?.task?.pickupAddress || orderTrack?.task?.dropoffAddress">
          <div class="sec-label">Route</div>
          <div class="route-card">
            <div class="rroute-inner">
              <div class="rstop" *ngIf="orderTrack?.task?.pickupAddress">
                <div class="rspine">
                  <div class="rpin rpin--a"></div>
                  <div class="rconnector" *ngIf="orderTrack?.task?.dropoffAddress"></div>
                </div>
                <div class="rstop-body">
                  <div class="rlbl rlbl--a">Pickup Point</div>
                  <div class="raddr">{{ orderTrack.task.pickupAddress }}</div>
                </div>
              </div>
              <div class="rstop" *ngIf="orderTrack?.task?.dropoffAddress">
                <div class="rspine"><div class="rpin rpin--b"></div></div>
                <div class="rstop-body">
                  <div class="rlbl rlbl--b">Drop-off Point</div>
                  <div class="raddr">{{ orderTrack.task.dropoffAddress }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="prule" style="margin-top:20px"
             *ngIf="orderTrack?.task?.pickupAddress || orderTrack?.task?.dropoffAddress"></div>

        <!-- CONTACTS -->
        <div class="psec anim-in" style="--d:280ms"
             *ngIf="orderTrack?.task?.pickupRecipientName || orderTrack?.task?.dropoffRecipientName ||
                    orderTrack?.task?.pickupRecipientPhone || orderTrack?.task?.dropoffRecipientPhone">
          <div class="sec-label">Customer Info</div>
          <div class="customer-info-list">
            <div class="customer-info-card customer-info-card--pick"
                 *ngIf="orderTrack?.task?.pickupRecipientName || orderTrack?.task?.pickupRecipientPhone">
              <span class="customer-info-badge customer-info-badge--pick">Pickup</span>
              <p class="customer-info-line">
                <span class="customer-info-label">Name :</span>
                <span class="customer-info-value">{{ orderTrack?.task?.pickupRecipientName || '---' }}</span>
              </p>
              <!-- <div class="crow" *ngIf="orderTrack?.task?.pickupRecipientPhone">
                <svg width="10" height="10" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                <span>+{{ orderTrack.task.pickupRecipientPhone }}</span>
              </div>
              <a [href]="'tel:+' + orderTrack?.task?.pickupRecipientPhone"
                 *ngIf="orderTrack?.task?.pickupRecipientPhone"
                 class="cbtn cbtn--pick">
                <svg width="9" height="9" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                Call
              </a> -->
            </div>
            <div class="customer-info-card customer-info-card--drop"
                 *ngIf="orderTrack?.task?.dropoffRecipientName || orderTrack?.task?.dropoffRecipientPhone">
              <span class="customer-info-badge customer-info-badge--drop">Drop-off</span>
              <p class="customer-info-line">
                <span class="customer-info-label">Name :</span>
                <span class="customer-info-value">{{ orderTrack?.task?.dropoffRecipientName || '---' }}</span>
              </p>
              <!-- <div class="crow" *ngIf="orderTrack?.task?.dropoffRecipientPhone">
                <svg width="10" height="10" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                <span>+{{ orderTrack.task.dropoffRecipientPhone }}</span>
              </div>
              <a [href]="'tel:+' + orderTrack?.task?.dropoffRecipientPhone"
                 *ngIf="orderTrack?.task?.dropoffRecipientPhone"
                 class="cbtn cbtn--drop">
                <svg width="9" height="9" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                Call
              </a> -->
            </div>
          </div>
        </div>

        <!-- NOTES -->
        <div class="prule" style="margin-top:20px"
             *ngIf="orderTrack?.task?.pickupNote || orderTrack?.task?.dropoffNote"></div>
        <div class="psec anim-in" style="--d:320ms"
             *ngIf="orderTrack?.task?.pickupNote || orderTrack?.task?.dropoffNote">
          <div class="sec-label">Notes</div>
          <div class="notes-list">
            <div *ngIf="orderTrack?.task?.pickupNote" class="note-item note-item--pick">
              <div class="note-tag note-tag--pick">
                <svg width="9" height="9" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                Pickup Note
              </div>
              <div class="note-text">{{ orderTrack.task.pickupNote }}</div>
            </div>
            <div *ngIf="orderTrack?.task?.dropoffNote" class="note-item note-item--drop">
              <div class="note-tag note-tag--drop">
                <svg width="9" height="9" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                Drop-off Note
              </div>
              <div class="note-text">{{ orderTrack.task.dropoffNote }}</div>
            </div>
          </div>
        </div>

        <!-- CUSTOMER CARE -->
        <div class="prule" style="margin-top:20px"
             *ngIf="orderTrack?.isDriverCustomerCareNumber"></div>
        <div class="psec anim-in" style="--d:360ms" *ngIf="orderTrack?.isDriverCustomerCareNumber">
          <div class="sec-label">Customer Care</div>
          <div class="cc-row">
            <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
            <span>{{ orderTrack?.customerCareNumberString || '---' }}</span>
          </div>
        </div>

        <!-- TASK IDs -->
        <div class="prule" style="margin-top:20px"></div>
        <div class="psec psec--ids anim-in" style="--d:400ms">
          <button id="copy" (click)="copyClipBoard('copy')" class="id-chip">
            <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
            #{{ orderTrack?.task?.shortId || '---' }}
          </button>
          <button *ngIf="orderTrack?.task?.alternativeId"
                  id="customcopy"
                  (click)="copyClipBoardCustom('customcopy')"
                  class="id-chip id-chip--alt">
            <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
            {{ orderTrack.task.alternativeId }}
          </button>
        </div>

        <!-- TASK ACTIVITY -->
        <!-- <div class="prule" style="margin-top:20px" *ngIf="orderTrack?.timeline?.length > 0"></div> -->
        <!-- <div class="psec anim-in" style="--d:440ms" *ngIf="orderTrack?.timeline?.length > 0">
          <div class="sec-label">Task Activity</div>
          <div class="activity-timeline">
            @for (event of orderTrack.timeline.slice().reverse(); track $index; let first = $first; let last = $last) {
              <div class="atl-item" [class.atl-item--first]="first" [class.atl-item--last]="last">
                <div class="atl-spine">
                  <div class="atl-dot"
                       [class.atl-dot--green]="event.status === 9 || event.status === 6"
                       [class.atl-dot--indigo]="event.status === 3 || event.status === 7 || event.status === 2"
                       [class.atl-dot--red]="event.status === 10 || event.status === 11"
                       [class.atl-dot--amber]="event.status === 16 || event.status === 14"></div>
                  <div class="atl-line" *ngIf="!last"></div>
                </div>
                <div class="atl-body">
                  <div class="atl-text">{{ event.purpose }}</div>
                  <div class="atl-time">{{ global.dateFormat(event.displayDate) }}</div>
                </div>
              </div>
            }
          </div>
        </div> -->

        <!-- PAYMENT -->
        <!-- <div class="prule" style="margin-top:20px" *ngIf="orderTrack?.task?.chargeAmount"></div>
        <div class="psec anim-in" style="--d:480ms; padding-bottom:32px" *ngIf="orderTrack?.task?.chargeAmount">
          <div class="sec-label">Payment</div>
          <div class="payment-row">
            <span class="payment-label">Total Amount</span>
            <span class="payment-value">{{ orderTrack.task.chargeAmount }} KWD</span>
          </div>
        </div> -->

      </div><!-- /pbody -->
    </ng-container>

  </aside>

  <!-- ══════════ MAP SIDE ══════════ -->
  <div class="map-side">

    <!-- Map always visible -->
    <div id="map"></div>

    <!-- Top-right controls row -->
    <div class="map-controls-row">
      <!-- Task ID badge -->
      <div class="map-taskid" *ngIf="orderTrack?.task?.shortId">
        <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
        {{ orderTrack.task.shortId }}
      </div>

      <!-- Toggle details button -->
      <button class="panel-toggle-btn" (click)="togglePanel()" [title]="panelCollapsed ? 'Show details' : 'Hide details'">
        <!-- Show sidebar icon when panel is hidden -->
        <svg *ngIf="panelCollapsed" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <line x1="9" y1="3" x2="9" y2="21"/>
        </svg>
        <!-- Show X/close icon when panel is visible -->
        <svg *ngIf="!panelCollapsed" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <line x1="9" y1="3" x2="9" y2="21"/>
          <polyline points="16 8 13 12 16 16"/>
        </svg>
      </button>
    </div>

    <!-- Pickup / Drop-off legend -->
    <div class="map-legend" *ngIf="orderTrack?.task">
      <div class="ml-item ml-item--pick" *ngIf="orderTrack?.task?.pickupAddress">
        <span class="ml-dot ml-dot--indigo"></span> Pickup
      </div>
      <div class="ml-item ml-item--drop" *ngIf="orderTrack?.task?.dropoffAddress">
        <span class="ml-dot ml-dot--sage"></span> Drop-off
      </div>
    </div>

    <!-- ETA badge bottom-right (on map) -->
    <div class="map-eta"
         [class.map-eta--updating]="showUpdatePulse"
         *ngIf="!isTerminalState && totalDuration && totalDuration !== '' && totalDuration !== 'undefined'">
      <div class="meta-eyebrow">Arriving in</div>
      <div class="meta-big">{{ totalDuration }} <span>min</span></div>
      <div class="meta-confirm">
        <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
        On schedule
      </div>
    </div>

    <!-- ══════ TERMINAL STATUS OVERLAY (on map side) ══════ -->
    <div class="terminal-overlay" *ngIf="isTerminalState">
      <div class="to-card">
        <!-- Large status icon -->
        <div class="to-icon" [ngClass]="'to-icon--' + terminalBadgeClass">
          <svg *ngIf="terminalBadgeClass === 'badge-completed'" width="36" height="36" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
          <svg *ngIf="terminalBadgeClass === 'badge-cancelled'" width="36" height="36" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          <svg *ngIf="terminalBadgeClass === 'badge-returned'" width="36" height="36" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M3 10h11a4 4 0 010 8H3"/><polyline points="7 6 3 10 7 14"/></svg>
        </div>

        <!-- Status badge -->
        <div class="to-badge" [ngClass]="terminalBadgeClass">
          <svg *ngIf="terminalBadgeClass === 'badge-completed'" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
          <svg *ngIf="terminalBadgeClass === 'badge-cancelled'" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          <svg *ngIf="terminalBadgeClass === 'badge-returned'" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M3 10h11a4 4 0 010 8H3"/><polyline points="7 6 3 10 7 14"/></svg>
          {{ terminalStatusLabel | uppercase }}
        </div>

        <!-- Title & subtitle -->
        <h2 class="to-title">{{ terminalTitle }}</h2>
        <p class="to-sub">{{ terminalSubtitle }}</p>

        <!-- Driver card -->
        <div class="to-driver" *ngIf="orderTrack?.task?.driver">
          <div class="to-driver-avatar">{{ getDriverInitial() }}</div>
          <div class="to-driver-info">
            <div class="to-driver-label">{{ terminalActorLabel }}</div>
            <div class="to-driver-name">{{ terminalActorName }}</div>
          </div>
        </div>

        <!-- Timestamp -->
        <div class="to-timestamp">
          <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          {{ terminalTimestamp }}
        </div>
      </div>
    </div>

  </div><!-- /map-side -->

</div><!-- /wf-app -->

<p-toast key="wf-toast" position="top-center"></p-toast>
